<template>
  <div>
    <div id="deleteResultsModal" class="uk-modal" uk-modal>
      <div class="uk-modal-dialog">
        <div class="uk-modal-header">
          <h3 class="uk-modal-title">
            <i class="uil-check-circle text-success"></i> {{ $t('general.successfully_deleted') }}
          </h3>
        </div>
        <div class="uk-modal-body">
          <div v-if="deleteResults" class="delete-results">
            <h5 class="text-center mb-4">{{ $t('general.following_operations_completed') }}</h5>
            
            <div class="results-grid">
              <div 
                v-for="(value, key) in resultItems" 
                :key="key"
                class="result-item"
              >
                <div class="result-icon">
                  <i :class="getIconForKey(key)"></i>
                </div>
                <div class="result-content">
                  <div class="result-number">{{ value }}</div>
                  <div class="result-label">{{ $t(`general.${key}`) }}</div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="uk-modal-footer uk-text-right">
          <button class="uk-button" type="button" @click="closeModal">
            <i class="uil-check"></i> {{ $t('general.ok') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeleteResultsModal",
  props: {
    deleteResults: {
      type: Object,
      default: null
    }
  },
  computed: {
    resultItems() {
      if (!this.deleteResults) return {};
      
      const data = this.deleteResults.data || this.deleteResults;
      
      return {
        posts_soft_deleted: data.posts_soft_deleted || 0,
        comments_soft_deleted: data.comments_soft_deleted || 0,
        files_soft_deleted: data.files_soft_deleted || 0,
        shares_soft_deleted: data.shares_soft_deleted || 0,
        likes_deleted: data.likes_deleted || 0,
        dislikes_deleted: data.dislikes_deleted || 0,
        chunks: data.chunks || 0,
      };
    },
  },
  watch: {
    deleteResults: {
      handler(newVal) {
        if (newVal) {
        }
      },
      immediate: true
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    getIconForKey(key) {
      const iconMap = {
        posts_soft_deleted: 'uil-file',
        comments_soft_deleted: 'uil-comment',
        files_soft_deleted: 'uil-file-alt',
        shares_soft_deleted: 'uil-share-alt',
        likes_deleted: 'uil-heart',
        dislikes_deleted: 'uil-thumbs-down'
      };
      
      return iconMap[key] || 'uil-info-circle';
    }
  }
};
</script>

<style scoped>
/* Delete Results Modal Styles */
.delete-results {
  padding: 30px 0;
}

.results-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 30px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.result-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 24px 16px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  border: 1px solid rgba(0, 123, 255, 0.1);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  box-shadow: 
    0 8px 32px rgba(0, 123, 255, 0.08),
    0 4px 16px rgba(0, 123, 255, 0.04),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);
}

.result-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: #007bff;
  opacity: 0;
  transition: opacity 0.4s ease;
}

.result-item::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 123, 255, 0.05);
  opacity: 0;
  transition: opacity 0.4s ease;
}


.result-icon {
  margin-bottom: 16px;
  font-size: 32px;
  color: #007bff;
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 123, 255, 0.1);
  border-radius: 50%;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.result-icon::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 123, 255, 0.2);
  border-radius: 50%;
  transform: scale(0);
  transition: transform 0.4s ease;
}


.result-content {
  width: 100%;
}

.result-number {
  font-size: 28px;
  font-weight: 800;
  color: #007bff;
  line-height: 1;
  margin-bottom: 10px;
  text-shadow: none;
}

.result-label {
  font-size: 10px;
  color: #6c757d;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  line-height: 1.3;
}

/* Modal Dialog */
.uk-modal-dialog {
  border-radius: 20px;
  box-shadow: 
    0 25px 100px rgba(0, 0, 0, 0.15),
    0 10px 40px rgba(0, 0, 0, 0.1),
    0 0 0 1px rgba(255, 255, 255, 0.1);
  max-width: 700px;
  margin: 2rem auto;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.uk-modal-body {
  padding: 30px;
}

/* Modal Header */
.uk-modal-header {
  background: #007bff;
  color: white;
  border-radius: 20px 20px 0 0;
  padding: 25px 30px;
  border-bottom: none;
  position: relative;
  overflow: hidden;
}

.uk-modal-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="modern-grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="20" cy="20" r="0.8" fill="rgba(255,255,255,0.15)"/><circle cx="80" cy="80" r="0.8" fill="rgba(255,255,255,0.15)"/><circle cx="40" cy="10" r="0.6" fill="rgba(255,255,255,0.1)"/><circle cx="10" cy="70" r="0.6" fill="rgba(255,255,255,0.1)"/><circle cx="90" cy="30" r="0.6" fill="rgba(255,255,255,0.1)"/><circle cx="60" cy="90" r="0.4" fill="rgba(255,255,255,0.08)"/><circle cx="30" cy="50" r="0.4" fill="rgba(255,255,255,0.08)"/></pattern></defs><rect width="100" height="100" fill="url(%23modern-grain)"/></svg>');
  opacity: 0.3;
}

.uk-modal-title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  position: relative;
  z-index: 1;
  letter-spacing: -0.3px;
  color: white;
}

.uk-modal-title i {
  margin-right: 12px;
  font-size: 24px;
  color: white;
  filter: drop-shadow(0 2px 4px rgba(255, 255, 255, 0.3));
}

/* Modal Footer */
.uk-modal-footer {
  background: rgba(248, 250, 252, 0.8);
  backdrop-filter: blur(20px);
  border-radius: 0 0 20px 20px;
  padding: 20px 30px;
  border-top: 1px solid rgba(226, 232, 240, 0.6);
}

.uk-modal-footer .uk-button {
  background: #007bff;
  border: none;
  color: white;
  font-weight: 600;
  padding: 12px 28px;
  border-radius: 10px;
  transition: none;
  box-shadow: 
    0 8px 25px rgba(0, 123, 255, 0.3),
    0 4px 15px rgba(0, 86, 179, 0.2);
  position: relative;
  overflow: hidden;
  font-size: 14px;
  letter-spacing: 0.3px;
}

.uk-modal-footer .uk-button::before {
  display: none;
}

 

.uk-modal-footer .uk-button:active {
  transform: none;
}

.uk-modal-footer .uk-button i {
  margin-right: 8px;
  font-size: 16px;
  color: white;
}

/* Enhanced Typography */
.delete-results h5 {
  color: #495057;
  font-weight: 600;
  margin-bottom: 25px;
  font-size: 16px;
  letter-spacing: -0.2px;
  text-align: center;
}

/* Responsive Design */
@media (max-width: 768px) {
  .uk-modal-dialog {
    width: 95%;
    margin: 1rem auto;
    border-radius: 16px;
  }
  
  .results-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    max-width: 100%;
  }
  
  .result-item {
    padding: 20px 12px;
    border-radius: 14px;
  }
  
  .result-icon {
    font-size: 28px;
    width: 56px;
    height: 56px;
  }
  
  .result-number {
    font-size: 24px;
  }
  
  .result-label {
    font-size: 9px;
  }
  
  .uk-modal-body {
    padding: 25px 20px;
  }
  
  .uk-modal-header {
    padding: 20px;
    border-radius: 16px 16px 0 0;
  }
  
  .uk-modal-footer {
    padding: 18px 20px;
    border-radius: 0 0 16px 16px;
  }
}

@media (max-width: 480px) {
  .results-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .uk-modal-dialog {
    width: 98%;
    margin: 0.5rem auto;
    border-radius: 14px;
  }
  
  .uk-modal-header {
    border-radius: 14px 14px 0 0;
  }
  
  .uk-modal-footer {
    border-radius: 0 0 14px 14px;
  }
}

/* Animation */
.uk-modal {
  animation: modernModalFadeIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes modernModalFadeIn {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* Enhanced Focus States */
.uk-modal-dialog:focus-within {
  outline: 2px solid #007bff;
  outline-offset: 3px;
}

.uk-button:focus {
  outline: 2px solid #0056b3;
  outline-offset: 3px;
}

/* Smooth scrolling for modal content */
.uk-modal-body {
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 #f1f5f9;
}

.uk-modal-body::-webkit-scrollbar {
  width: 6px;
}

.uk-modal-body::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.uk-modal-body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.uk-modal-body::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Glassmorphism effect for better depth */
.uk-modal-dialog::before {
  content: '';
  position: absolute;
  top: -1px;
  left: -1px;
  right: -1px;
  bottom: -1px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  z-index: -1;
}
</style>
